import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../../modules';
import { setMenuID } from '../../../modules/tabMenu';
import {
  searchKeywordState,
  setSearchKeyword,
} from '../../../modules/searchKeyword';

import {
  getSearchAsync,
  getPopularKeywordAsync,
  setIsMoreInfoAttachment,
  setIsMoreInfoImage,
  setIsMoreInfoResult,
  tabResultState,
} from '../../../modules/tabResult';
import {
  GetSearchParamType,
  GetPopularKeywordParamType,
} from '../../../lib/tabResult/type';
import Result from '../../../components/search/tabResult';
import { PostConsumptionBodyType } from '../../../lib/common/type';
import { postConsumptionAsync } from '../../../modules/common';

function ResultContainer() {
  const {
    relatedWord,
    popularKeyword,
    travel_info,
    recommended_info,
    course_info,
    imageResult,
    attachResult,
    wikiData,
    isMoreInfoAttach,
    isMoreInfoImage,
    isMoreInfoResult,
    loading,
    spellCheckerData,
  } = useSelector((state: RootState) => state.tabResult);

  const dispatch = useDispatch();

  const onSetIsMoreInfoResult = (
    isMoreInfoResult: tabResultState['isMoreInfoResult']
  ) => {
    dispatch(setIsMoreInfoResult(isMoreInfoResult));
  };

  const onSetIsMoreInfoAttachment = (
    isMoreInfoAttach: tabResultState['isMoreInfoAttach']
  ) => {
    dispatch(setIsMoreInfoAttachment(isMoreInfoAttach));
  };

  const onSetIsMoreInfoImage = (
    isMoreInfoImage: tabResultState['isMoreInfoImage']
  ) => {
    dispatch(setIsMoreInfoImage(isMoreInfoImage));
  };

  const onSetMenuID = (selectedMenuId: number) => {
    dispatch(setMenuID(selectedMenuId));
  };

  const onGetSearch = (info: GetSearchParamType) => {
    dispatch(getSearchAsync.request(info));
  };

  const onGetPopularKeyword = (info: GetPopularKeywordParamType) => {
    dispatch(getPopularKeywordAsync.request(info));
  };

  const onSetSearchKeyword = (
    searchKeyword: searchKeywordState['searchKeyword']
  ) => {
    dispatch(setSearchKeyword(searchKeyword));
  };

  const onPostConsumption = (info: PostConsumptionBodyType) => {
    dispatch(postConsumptionAsync.request(info));
  };

  return (
    <Result
      travel_info={travel_info}
      recommended_info={recommended_info}
      course_info={course_info}
      imageResult={imageResult}
      attachResult={attachResult}
      relatedWord={relatedWord}
      popularKeyword={popularKeyword}
      wikiData={wikiData}
      isMoreInfoResult={isMoreInfoResult}
      isMoreInfoAttach={isMoreInfoAttach}
      isMoreInfoImage={isMoreInfoImage}
      loading={loading}
      spellCheckerData={spellCheckerData}
      onSetMenuID={onSetMenuID}
      onGetSearch={onGetSearch}
      onGetPopularKeyword={onGetPopularKeyword}
      onSetIsMoreInfoResult={onSetIsMoreInfoResult}
      onSetIsMoreInfoAttachment={onSetIsMoreInfoAttachment}
      onSetIsMoreInfoImage={onSetIsMoreInfoImage}
      onSetSearchKeyword={onSetSearchKeyword}
      onPostConsumption={onPostConsumption}
    />
  );
}

export default ResultContainer;
